<template>
  <v-card flat>
    <v-card-title>
      <h4 class="earth-color">SCHEDULE UNAVAILABILITY</h4>
    </v-card-title>
    <v-container>
      <v-form  @submit.prevent="_addAvailabilitySchedule()">
        <v-layout row wrap>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-dialog
                ref="dialog"
                persistent
                v-model="modal"
                lazy
                full-width
                width="290px"
                :return-value.sync="availability.start_date"
              >
                <v-text-field
                  slot="activator"
                  label="Start Date"
                  v-model="availability.start_date"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="availability.start_date"
                  scrollable
                  :min="today"
                >
                  <v-spacer></v-spacer>
                  <v-btn :depressed="true" flat color="primary" @click="modal = false">Cancel</v-btn>
                  <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(availability.start_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-dialog
                ref="dialog1"
                persistent
                v-model="modal1"
                lazy
                full-width
                width="290px"
                :return-value.sync="availability.end_date"
              >
                <v-text-field
                  slot="activator"
                  label="End Date"
                  v-model="availability.end_date"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="availability.end_date"
                  scrollable
                  :min="availability.start_date"
                >
                  <v-spacer></v-spacer>
                  <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
                  <v-btn :depressed="true" flat color="primary" @click="$refs.dialog1.save(availability.end_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 xs12 sm12>
            <v-container>
              <v-text-field
                label="Slots"
                v-model="availability.quantity"
                type="number"
                min="0"
                :max="singleFacility.maximum_guests"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg12 md12 sm12 xs12>
            <v-container>
              <v-textarea
                name="input-7-1"
                box
                label="Reason"
                v-model="availability.reason"
                auto-grow
              >
              </v-textarea>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-btn :depressed="true" color="primary" @click="_addAvailabilitySchedule" type="submit">Add UnAvailability Schedule</v-btn>
            </v-container>
          </v-flex>
        </v-layout>
      </v-form>
      <div class="col-md-12">
        <table cellpadding="1" cellspacing="1" class="table table-bordered">
          <thead>
          <tr>
            <td>Created At</td>
            <td>Start Date</td>
            <td>End Date</td>
            <td>Slots</td>
            <td>Reason</td>
            <td>Added By</td>
            <td>Action</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(schedule, key) in facilityUnavailabilitySchedule" :key="key">
            <td>{{formated_date(schedule.created_at)}}</td>
            <td>{{formated_date(schedule.unavailability_start_date)}}</td>
            <td>{{formated_date(schedule.unavailability_end_date)}}</td>
            <td>{{schedule.unavailability_number}}</td>
            <td>{{schedule.unavailability_reason}}</td>
            <td>{{schedule.user}}</td>
            <td>
              <v-btn
                :depressed="true"
                small
                color="success"
                @click="_showEditDialog(schedule)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-dialog v-model="edit_availability_dialog" persistent max-width="700px">
                <v-card>
                  <v-card-title>
                    <h4 class="earth-color"> EDIT UNAVAILABILITY SCHEDULE </h4>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md4>
                          <v-menu
                            v-model="edit_availability.start_date_dialog"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px"
                          >
                            <template slot="activator">
                              <v-text-field
                                v-model="edit_availability.start_date"
                                label="Start Date"
                                hint="YYYY/MM/DD"
                                persistent-hint
                              ></v-text-field>
                            </template>
                            <v-date-picker color="primary" v-model="edit_availability.start_date" no-title @input="edit_availability.start_date_dialog = false"></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-menu
                            v-model="edit_availability.end_date_dialog"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px"
                          >
                            <template slot="activator">
                              <v-text-field
                                v-model="edit_availability.end_date"
                                label="End Date"
                                hint="YYYY/MM/DD"
                                persistent-hint
                              ></v-text-field>
                            </template>
                            <v-date-picker color="primary" v-model="edit_availability.end_date" no-title @input="edit_availability.end_date_dialog = false" :min="edit_availability.start_date"></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-text-field
                            v-model="edit_availability.quantity"
                            label="Slots"
                            hint="Slots"
                            type="number"
                            min="0"
                            :max="singleInventory.maximum_guests"
                            persistent-hint
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex lg12 md12 sm12 xs12>
                          <v-textarea
                            name="input-7-1"
                            box
                            label="Reason"
                            v-model="edit_availability.reason"
                            auto-grow
                          >
                          </v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="red darken-1" flat @click="edit_availability_dialog = false">Close</v-btn>
                    <v-btn color="green" flat @click="_editSchedule">Update</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-btn :depressed="true" small color="error" @click="_deleteAvailabilitySchedule(schedule.facility_unavailability_public_id)"><v-icon>clear</v-icon></v-btn>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'FacilityAvailability',
  data () {
    return {
      dialog: false,
      dialog1: false,
      modal: false,
      modal1: false,
      edit_availability_dialog: false,
      today: this.$moment().format('YYYY-MM-DD'),
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      availability: {
        facility_id: this.$route.params.facility_id,
        start_date: '',
        end_date: '',
        quantity: '',
        reason: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      },
      edit_availability: {
        facility_id: this.$route.params.facility_id,
        schedule_id: '',
        start_date: '',
        end_date: '',
        start_date_dialog: false,
        end_date_dialog: false,
        reason: '',
        quantity: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  beforeCreate () {
    this.$store.dispatch('get_facility_availability_schedule', this.$route.params.facility_id)
  },
  methods: {
    _addAvailabilitySchedule: function () {
      localStorage.setItem('facility_availability', {})
      localStorage.setItem('facility_availability', JSON.stringify(this.availability))
      let data = JSON.parse(localStorage.getItem('facility_availability'))
      this.availability.start_date = ''
      this.availability.end_date = ''
      this.availability.reason = ''
      this.availability.quantity = ''
      this.$store.dispatch('post_facility_availability_schedule', data)
    },
    _deleteAvailabilitySchedule: function (scheduleId) {
      var data = {
        schedule_id: scheduleId,
        session_id: localStorage.getItem('lkjhgfdsa'),
        facility_id: this.$route.params.facility_id
      }
      this.$store.dispatch('delete_facility_availability_schedule', data)
    },
    _showEditDialog (schedule) {
      this.edit_availability_dialog = true
      this.edit_availability.schedule_id = schedule.facility_unavailability_public_id
      this.edit_availability.start_date = this.$moment(schedule.unavailability_start_date).format('YYYY-MM-DD')
      this.edit_availability.end_date = this.$moment(schedule.unavailability_end_date).format('YYYY-MM-DD')
      this.edit_availability.quantity = schedule.unavailability_number
      this.edit_availability.reason = schedule.unavailability_reason
    },
    _editSchedule () {
      this.edit_availability_dialog = false
      this.$store.dispatch('edit_facility_availability_schedule', this.edit_availability)
    }
  }
}
</script>

<style scoped>

</style>
